import { useState } from 'react'

export const useSetup = () => {
  const [isReady, setIsReady] = useState(false)

  const setReady = () => {
    const body = document.body

    if (body.style.display !== 'block') {
      body.style.display = 'block'
      setIsReady(true)
    }
  }

  return { isReady, setReady }
}
